export default __webpack_public_path__ + "static/media/active-working-shaded.69d13340.png";